import Table from 'core/table';

import { usePaginationContext } from 'utils/contexts/pagination';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ASCENDING, DESCENDING } from 'constants/sortDirections';
import { useSortingContext } from 'utils/contexts/sorting';

import { useFilterContext } from '../contexts/FilterContext';
import { useQueryContext } from '../contexts/QueryContext';
import { FiltersToolbar } from './FiltersToolbar';
import { COLUMNS, PAGE_SIZES } from '../constants';

export const ListTable = () => {
  const { search, setSearch } = useFilterContext();
  const { totalListCount, lists } = useQueryContext();
  const { sortBy, setSortBy, sortDirection, setSortDirection } = useSortingContext();
  const { currentPage, setCurrentPage, pageSize, setPageSize } = usePaginationContext();

  return (
    <Table
      data-test="manage-lists-table"
      appearance="iterable"
      columns={COLUMNS}
      showFilterInput
      filterPlaceholder="Filter lists by ID or name..."
      onChangeFilter={(_, { filter }) => setSearch(filter)}
      onChangeSort={(_, { orderBy, sorting }) => {
        setSortBy(orderBy);
        setSortDirection(
          sorting === ASCENDING ? SORT_DIRECTIONS.ASCENDING : SORT_DIRECTIONS.DESCENDING,
        );
      }}
      rows={lists}
      total={totalListCount}
      page={currentPage}
      pageSize={pageSize}
      pageSizes={PAGE_SIZES}
      onChangePage={(_, { page }) => setCurrentPage(page)}
      onChangePageSize={(_, { pageSize: newPageSize }) => setPageSize(newPageSize)}
      filter={search}
      sorting={sortDirection === SORT_DIRECTIONS.ASCENDING ? ASCENDING : DESCENDING}
      orderBy={sortBy}
      toolbarContent={<FiltersToolbar />}
    />
  );
};
